import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthEndpoint } from '@fullyops/legacy/data/index';
import { ToastService } from '@fullyops/shared/services/toast/toast.service';
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionExpirationInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private auth: AuthEndpoint,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      // We use catchError instead of tap so that the error is not propagated to further
      // interceptors, in particular ErrorHandingInterceptor.
      catchError((err: HttpErrorResponse) => {
        if (
          err.status < 500 &&
          typeof err.error === 'string' &&
          (err.error.includes('JWT') ||
            err.error.includes('no tenant specified'))
        ) {
          this.auth.logout();
          this.toastService.showTranslatedErrorMessage('error:sessionExpired');
          // result value doesn't matter, we're reloading anyway
          return of(null);
        }
        throw err;
      }),
    );
  }
}
